import { createContext, useContext } from 'react';
import { WidgetTrackingData } from 'shared/components/AdPlatformWidgets/types';

interface ITrackingContext {
  attachObserver: (ref: HTMLElement, trackingData: WidgetTrackingData) => void;
  detachObserver: (ref: HTMLElement) => void;
  onWidgetClick: (trackingData: WidgetTrackingData) => void;
}

const EMPTY_FUNC = () => {
  /* Do Nothing */
};

const initialValue: ITrackingContext = {
  attachObserver: EMPTY_FUNC,
  detachObserver: EMPTY_FUNC,
  onWidgetClick: EMPTY_FUNC,
};

const TrackingContext = createContext(initialValue);
export const useTrackingContext = () => useContext(TrackingContext);

export default TrackingContext;
